import { AxiosRequestConfig } from "axios";
import { apiConfig } from "../config/apiConfig";
import { Api } from "./Api";
import { Refund, RefundRequest } from "../model/final_balance/refund";

class RefundApi extends Api {
  constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig);
  }
  /*
   * Ideally would have a get method in future
  public get
  */

  public create = async (request: RefundRequest) => this.post("/overpayment", request);
}

export const refundApi = new RefundApi(apiConfig);
